import {IAppConfiguration} from '@/models/appConfig.models';
import { environment } from './../../environments/environment';

/**
 * Environment service provider created using: https://www.jvandemo.com/how-to-use-environment-variables-to-configure-your-angular-application-without-a-rebuild/
 */
export class EnvironmentService implements IAppConfiguration {
	public APIBASEURL: string;
	public DSN_KEY?: string;

	constructor() {
		this.APIBASEURL = environment.APIBASEURL;
		this.DSN_KEY = environment.DSN_KEY;
	}

}

export const EnvironmentServiceFactory = () => {
	// create env
	const env = new EnvironmentService();

	// read environment variables from browser window
	const browserWindow = window || {};
	const browserWindowEnv = browserWindow['__env'] || {};

	// assign environment variables from browser window to env
	// in the current implementation, properties from env.js overwrite defaults from the EnvService.
	// if needed, a deep merge can be performed here to merge properties instead of overwriting them.
	for (const key in browserWindowEnv) {
		if (browserWindowEnv.hasOwnProperty(key)) {
			env[key] = window['__env'][key];
		}
	}

	return env;
};

export const EnvironmentServiceProvider = {
	provide: EnvironmentService,
	useFactory: EnvironmentServiceFactory,
	deps: [],
};
